export default class Country {
  constructor(rest) {
    this.rest = rest
  }

  setParams(params = {}) {
    return this.rest.post('/postback/set-params', params)
  }
}
